import React from "react";
import { MapProvider } from "contexts/MapContext";
import Map from "components/widgets/Map";

const MapView = () => {
	return <Map />;
};

export default MapView;
